import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationItem, NotificationsListFilters, NotificationsSummary } from './notifications.model';
import { PaginatedResponse } from '@/shared/models/paginated-response.model';

interface MarkNotificationsReadPayload {
    readAll: boolean;
    notificationIds?: number[];
}

@Injectable({
    providedIn: 'root'
})
export class NotificationsApiService {
    private readonly apiUrl = environment.urls.api;
    private readonly baseUrl = environment.urls.baseUrl;
    private readonly apiV1version = environment.urls.apiVersions.v1;
    private readonly apibaseV1Url = `${this.baseUrl}${this.apiV1version}`;

    private readonly _httpClient = inject(HttpClient);

    /** GET /api/v1/Notifications/summary */
    public getNotificationsSummary(): Observable<NotificationsSummary> {
        return this._httpClient.get<{ data?: NotificationsSummary } & NotificationsSummary>(`${this.apiUrl}/Notifications/summary`).pipe(map((res) => res.data ?? res));
    }

    public getNotifications(page: number, pageSize: number, filters: NotificationsListFilters = {}): Observable<PaginatedResponse<NotificationItem>> {
        const params = new URLSearchParams({
            Page: String(page),
            PageSize: String(pageSize)
        });

        if (filters.status !== null && filters.status !== undefined) {
            params.set('Status', String(filters.status));
        }

        return this._httpClient
            .get<{ data?: { items?: NotificationItem[]; total?: number; page?: number; pageSize?: number }; items?: NotificationItem[]; total?: number; page?: number; pageSize?: number }>(`${this.apibaseV1Url}/Notifications?${params.toString()}`)
            .pipe(
                map((res) => {
                    const data = (res as { data?: { items?: NotificationItem[]; total?: number; page?: number; pageSize?: number } }).data ?? (res as { items?: NotificationItem[]; total?: number; page?: number; pageSize?: number });
                    return {
                        items: data.items ?? [],
                        total: data.total ?? 0,
                        page: data.page ?? page,
                        pageSize: data.pageSize ?? pageSize
                    };
                })
            );
    }

    public markAllNotificationsAsRead(readAll: boolean, notificationIds: number[] = []): Observable<any> {
        const body: MarkNotificationsReadPayload = readAll ? { readAll } : { readAll, notificationIds };

        return this._httpClient.put(`${this.apiUrl}/Notifications/read`, body);
    }

    /** PUT /api/v1/Notifications/{notificationId}/read */
    public markNotificationAsRead(notificationId: number): Observable<any> {
        return this._httpClient.put(`${this.apiUrl}/Notifications/${notificationId}/read`, {});
    }
}
